import { useEffect, useState } from 'react';
export const useFilePreview = ({ value, type }) => {
    const [previewUrl, setPreviewUrl] = useState(null);
    useEffect(() => {
        if (value && type === 'image') {
            if (typeof value === 'string') {
                setPreviewUrl(value);
            }
            else {
                const url = URL.createObjectURL(value);
                setPreviewUrl(url);
                return () => {
                    URL.revokeObjectURL(url);
                };
            }
        }
        else {
            setPreviewUrl(null);
        }
    }, [value, type]);
    const revokePreviewUrl = () => {
        if (previewUrl?.startsWith('blob:')) {
            URL.revokeObjectURL(previewUrl);
        }
        setPreviewUrl(null);
    };
    const setPreviewFromFile = (file) => {
        if (previewUrl?.startsWith('blob:')) {
            URL.revokeObjectURL(previewUrl);
        }
        setPreviewUrl(URL.createObjectURL(file));
    };
    return {
        previewUrl,
        revokePreviewUrl,
        setPreviewFromFile,
    };
};
